<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="bookings"
      :pagination.sync="pagination"
      :hide-default-footer="true"
      ref="bookingSummaryList"
    >
      <template v-slot:item="props">
        <tr>
          <td style="width:9%;">{{ props.item.pickup_time }}</td>
          <td style="width:1%;">{{ props.item.num_people }}</td>

          <td style="width:32%;">
            <div class="fixed-booking-table-row">{{ props.item.pickup_location }}</div>
          </td>
          <td style="width:3%; cursor: pointer">
            <ViasForBooking :booking="props.item" />
          </td>
          <td style="width:30%;">
            <div class="fixed-booking-table-row" v-html="destinationForBooking(props.item)"></div>
          </td>
          <td style="width:10%;">
            <div>
              <span>
                <a
                  href="#"
                  v-on:click.stop="goToUser(props.item.user_id)"
                >{{ props.item.user_name }}</a>
                <br />
                <p v-if="props.item.business_customer_name">{{props.item.business_customer_name}}</p>
                <p v-if="props.item.ref_num">{{props.item.ref_num}}</p>
              </span>
            </div>
          </td>
          <td style="width:10%">
            <v-edit-dialog @save="save" @cancel="cancel" @open="open" @close="close">
              <p>
                <b>{{props.item.preassigned_driver_callsign}}</b>
                {{ props.item.preassigned_driver_name }}
              </p>
              <template v-slot:input>
                <SelectableDriverDropdownInput
                  v-model="props.item.preassigned_driver_id"
                  hide-details
                  label="Preassign Driver"
                  :bookingSummary="props.item"
                  @preassigned="preassigned"
                ></SelectableDriverDropdownInput>
              </template>
            </v-edit-dialog>
          </td>
          <td style="width: 5%; text-transform: capitalize;">{{props.item.booking_type}}</td>
          <td>
            <v-row style="width: 110px;">
              <v-flex>
                <v-btn class="text-none" x-small v-on:click.stop="goToBooking(props.item.id)">View</v-btn>
              </v-flex>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog
      v-model="viewBookingDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card style="background-color: #f4f5f9;">
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click="closeViewBookingDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>View/Edit Booking #{{currentBookingID + " - " + (bookingForm != null ? bookingForm.booking.state : "")}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex v-if="loadingEditBooking == true">
          <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
        </v-flex>
        <LargeBookForm
          :updateMode="true"
          v-if="viewBookingDialog == true"
          :bookingForm="bookingForm"
          @cancelledBooking="cancelledBooking"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LargeBookForm from "@/components/booking/LargeBookForm.vue";
import { BookingForm } from "@/components/util/BookingForm.js";

import SelectableDriverDropdownInput from "@/components/widget/input/SelectableDriverDropdownInput.vue";
import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

export default {
  name: "booking_summary_list_calendar",
  components: {
    LargeBookForm,
    SelectableDriverDropdownInput,
    ViasForBooking,
  },
  props: {
    bookings: Array,
    paginationProp: Object,
    rideTypes: Array,
  },
  mounted: async function () {
    if (this.$route.query.bookingID) {
      this.goToBooking(this.$route.query.bookingID);
      this.$route.query.bookingID = null;
    }
  },
  data: function () {
    return {
      dialog: Object,
      pagination: this.paginationProp,
      currentBookingID: -1,
      viewBookingDialog: false,
      loadingEditBooking: false,
      bookingForm: null,
      headers: [
        {
          text: "Pickup Time",
          align: "left",
          sortable: false,
          value: "pickup_time",
        },
        {
          text: "PAX",
          align: "left",
          sortable: false,
          value: "pax",
        },
        {
          text: "Pickup",
          align: "left",
          sortable: false,
          value: "pickup",
        },
        {
          text: "Via(s)",
          align: "left",
          sortable: false,
          value: "vias",
        },
        {
          text: "Destination",
          align: "left",
          sortable: false,
          value: "destinations",
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Driver",
          align: "left",
          sortable: false,
          value: "driver",
        },
        {
          text: "Source",
          align: "left",
          sortable: false,
          value: "state",
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  methods: {
    preassigned(bookingSummary) {
      this.$emit("preassigned", bookingSummary);
    },
    cancelledBooking() {
      console.log("Booking cancelled");

      var vm = this;
      this.bookings.forEach(function (b) {
        if (b.id == vm.currentBookingID) {
          b.state = "cancelled";
        }
      });
      this.cancelEditBooking();
    },
    save() {
      console.log("save");
    },
    cancel() {
      console.log("cancel");
    },
    close() {
      console.log("close");
    },
    open() {
      console.log("open");
    },
    async getBookingForEdit(bookingID) {
      this.loadingEditBooking = true;

      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.loadingEditBooking = false;

        if (response.error == null || response.error == "no_error") {
          return response.data;
        } else {
          return response.data.error;
        }
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
    goToBooking: function (id) {
      this.cancelEditBooking(false);

      this.currentBookingID = id;

      var vm = this;

      vm.$nextTick(async function () {
        this.viewBookingDialog = true;

        var booking = await vm.getBookingForEdit(id);

        console.log("booking");
        console.log(booking);

        if (typeof booking === "string") {
          console.log("Error for edit booking");
          this.editBookingError = booking;
          alert(this.editBookingError);
        } else {
          var bookingUser = BookingForm.jsonToBookingFormBookingUser(booking);

          this.bookingForm = new BookingForm(
            this.rideTypes,
            bookingUser,
            this.$store
          );
        }

        this.loadingEditBooking = false;
      });
    },
    cancelEditBooking: function (reload) {
      console.log("Hiding booking dialog");
      this.bookingForm = null;

      this.loadingEditBooking = true;
      this.editBookingError = null;
      this.viewBookingDialog = false;

      if (reload != false) {
        this.$emit("reload", null);
      }
    },
    closeViewBookingDialog: function () {
      this.cancelEditBooking();
    },
    goToUser: function (id) {
      window.open(`/customer/view/${id}`, "_blank");
    },
    goToDriver: function (id) {
      window.open(`/driver/view/${id}`, "_blank");
    },
    destinationForBooking: function (booking) {
      var destinations = "-";

      if (booking.destinations.length > 0) {
        return booking.destinations[0].description;
      }

      return destinations;
    },
    ratingForItem: function (booking) {
      if (booking.rating) {
        return booking.rating + "⭐";
      } else {
        return "";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 4px !important;
}

thead th:not(:first-child) {
  padding: 0 8px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}
</style>
